import { render, staticRenderFns } from "./AnswerRender.vue?vue&type=template&id=2570d82f&functional=true"
import script from "./AnswerRender.vue?vue&type=script&lang=js"
export * from "./AnswerRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports